<template>
	<div>
		<div style="display: flex; justify-content: space-between; align-items: center;">
			<v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
			<p style="display: inline;" class="add-event-example-sub-header-light mb-0">Example {{exampleIndex+1}}/{{examples.length}}</p>
			<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
		</div>
		<p class="add-event-example-content"><i>Think you might have a great Add-on to offer, but not sure how to present it?</i></p>
		<p class="add-event-example-content">Check out these examples to get ideas:</p>
		<p class="add-event-example-sub-header-light">Description</p>
		<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].description"></p>
		<p class="add-event-example-sub-header-light mt-4">Time</p>
		<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].timeSlot"></p>
		<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].time"></p>
		<p class="add-event-example-sub-header-light mt-4">Fee</p>
		<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].fee"></p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			exampleIndex: 0,
			examples: [
				{
					description:
						'Morning Yoga with host and certified Vinyasa instructor and practitioner for over twenty years, Malory. We’ll focus on breathwork and warming up our minds and bodies to start the morning centered energized. What to bring: if you have a mat, please bring it!',
					timeSlot: 'Before the event',
					time: '8am - 8:45',
					fee: '$10'
				},
				{
					description:
						'Home-cooked 3 Course Lunch, prepared and served by Kristof, a chef and former restaurateur. About the menu: this meal is an ode to the experience of dining at my favorite Izakaya in Japan! I usually weave a few bites into our family meals, but by popular demand, I’ve decided to put more of those courses together for a complete, and absolutely delicious, Izakaya lunch.',
					timeSlot: 'During the event',
					time: '12p - 1pm',
					fee: '$12'
				},
				{
					description:
						'Guess what? I’m an Award-Winning LA Photographer. Since I have all the gear here set up and ready to go, I’m offering up to 4 headshot sessions (15 minutes each) while the work-sprints are underway. I’ll take about 30 pics and, after the event, put the finishing touches on 2 for your professional use. (And I will happily send you the remaining pics, just won’t be able to color correct, etc. for this deal. Thanks!',
					timeSlot: 'During the event',
					time: '9am - 1pm',
					fee: '$30'
				},
				{
					description:
						'Whether from stress, physical recovery, or long days working over the computer, I am offering 20 min Massages. I am a trained, certified Massage Therapist. A rejuvenated mind is more productive!',
					timeSlot: 'During the event',
					time: '10:30am - 2pm',
					fee: '$10'
				},
				{
					description:
						'Awesome 30 minute HiiT Quickie Workout, by host and founder of ThisIsFitWorkouts. If youd like to participate please bring an exercise mat or large towel, a water bottle, and workout clothes. There are locker rooms where you can change and fitness equipment will be provided. The workouts are modifiable to all levels!',
					timeSlot: 'After the event',
					time: '4:15 - 4:45',
					fee: '$5'
				},
				{
					description:
						'Pregame: Coffee and Chat. Come before the WRKPRTY begins to ease into the flow with coffee and conversations!',
					timeSlot: 'Before the event',
					time: '8:30am - 9am',
					fee: '$0'
				}
			]
		}
	},
	methods: {
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		}
	}
}
</script>
